import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const IdCardIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props}>
      <g fill="none">
        <path
          d="M21.5821 19.3608H2.41691C1.82171 19.3608 1.33691 18.876 1.33691 18.2808V5.71922C1.33691 5.12402 1.82171 4.63922 2.41691 4.63922H21.5821C22.1773 4.63922 22.6621 5.12402 22.6621 5.71922V18.2808C22.6621 18.876 22.1773 19.3608 21.5821 19.3608ZM2.77691 17.9208H21.2221V6.07922H2.77691V17.9208Z"
          fill="currentColor"
          className={`icon--${props.color}`}
        />
        <path
          d="M9.17751 13.6956V13.6632C9.17751 13.5816 9.2327 13.512 9.3107 13.4892C10.6919 13.086 11.6723 11.73 11.4851 10.1832C11.3171 8.79597 10.1951 7.68477 8.8067 7.52997C6.9695 7.32477 5.4071 8.76357 5.4071 10.5612C5.4071 11.9472 6.3359 13.1196 7.6043 13.4892C7.6823 13.512 7.73751 13.5816 7.73751 13.6632V13.6956C7.73751 13.782 7.6751 13.854 7.5911 13.872C5.6087 14.2752 4.1123 16.0296 4.1123 18.1296H5.5523C5.5523 16.5276 6.8555 15.2244 8.45751 15.2244C10.0595 15.2244 11.3627 16.5276 11.3627 18.1296H12.8027C12.8027 16.0308 11.3063 14.2752 9.3239 13.872C9.2387 13.8552 9.17751 13.782 9.17751 13.6956ZM6.8603 10.7724C6.7271 9.71997 7.61511 8.83197 8.66751 8.96517C9.38511 9.05637 9.9635 9.63477 10.0547 10.3524C10.1879 11.4048 9.29991 12.2928 8.24751 12.1596C7.53111 12.0684 6.9515 11.49 6.8603 10.7724Z"
          fill="currentColor"
          className={`icon--${props.color}`}
        />
        <path
          d="M18.3325 14.5584H14.2669C13.8697 14.5584 13.5469 14.2356 13.5469 13.8384C13.5469 13.4412 13.8697 13.1184 14.2669 13.1184H18.3325C18.7297 13.1184 19.0525 13.4412 19.0525 13.8384C19.0525 14.2356 18.7297 14.5584 18.3325 14.5584Z"
          fill="currentColor"
          className={`icon--${props.color}`}
        />
        <path
          d="M18.3325 11.6016H14.2669C13.8697 11.6016 13.5469 11.2788 13.5469 10.8816C13.5469 10.4844 13.8697 10.1616 14.2669 10.1616H18.3325C18.7297 10.1616 19.0525 10.4844 19.0525 10.8816C19.0525 11.2788 18.7297 11.6016 18.3325 11.6016Z"
          fill="currentColor"
          className={`icon--${props.color}`}
        />
      </g>
    </IconSvgWrapper>
  );
};

export default IdCardIcon;
